module.exports = __webpack_public_path__ + "fa2ccf449467c87af90e18bb828ea73d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-30.png
// module id = 2540
// module chunks = 0